import axios from 'axios'

// Store and router are injected after initialization to avoid circular dependencies
let _store = null;
let _router = null;

export const setStore = (store) => { _store = store; };
export const setRouter = (router) => { _router = router; };

const instance = axios.create({
    baseURL: import.meta.env.PUBLIC_API_HOST,
    withCredentials: true,
    headers: {
        crossDomain: true,
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Access-Control-Allow-Origin': '*',
    },
});

// Add a response interceptor
instance.interceptors.response.use(
    function (response) {
        return response
    },
    function (error) {
        console.log(error);
        switch (error.response.status) {
            case 401:
                if (_store?.state?.auth?.authenticated) {
                    console.log('your token is outdated')
                    _store.dispatch("notifications/addNotification", { message: 'Please log in again', type: 'warning' });
                    _store.dispatch('auth/logout')
                    if (_router) _router.push('/')
                }
                break;
            case 402:
                console.log('payment or payment data is needed')
                if (_store) {
                    _store.dispatch("notifications/addNotification", { message: 'Payment or payment data is needed', type: 'warning' });
                }
                if (_router) _router.push({ name: 'payment' })
                break;
            case 419:
                console.log('crsf token new request')
                instance.request("GET", '/csrf-cookie')
                break;
            case 500:
                console.log('server error');
                if (_store) {
                    _store.dispatch("notifications/addNotification", { message: 'Server error', type: 'error' });
                }
                break;
        }

        return Promise.reject(error);
    });

// Add a request interceptor
instance.interceptors.request.use(function (config) {
    const token = _store?.state?.auth?.token;
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

export const useHttp = () => instance
